import { render } from "./ContactosDisponibles.vue?vue&type=template&id=6c2efd78&scoped=true"
import script from "./ContactosDisponibles.vue?vue&type=script&lang=js"
export * from "./ContactosDisponibles.vue?vue&type=script&lang=js"

import "./ContactosDisponibles.vue?vue&type=style&index=0&id=6c2efd78&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2efd78"]])

export default __exports__